import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { shape, string, number, arrayOf } from 'prop-types';
import { ShippingItem } from '../../molecules';
import { HorizontalRule, Box } from '../../atoms';

const ShippingList = _ref => {
  let {
    items,
    currency
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["items", "currency"]);

  return /*#__PURE__*/React.createElement(Box, props, items.map((shippingItem, index) => /*#__PURE__*/React.createElement(Box, {
    key: `shipping-item-${index}`
  }, !!index && /*#__PURE__*/React.createElement(HorizontalRule, null), /*#__PURE__*/React.createElement(ShippingItem, _extends({
    currency: currency
  }, shippingItem)))));
};

ShippingList.defaultProps = {
  items: [],
  currency: 'BRL'
};
process.env.NODE_ENV !== "production" ? ShippingList.propTypes = {
  currency: string,
  items: arrayOf(shape({
    id: string,
    type: string,
    description: string,
    complement: string,
    time: number,
    price: string
  }))
} : void 0;
export default ShippingList;